import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myCafateriaCalculatedBenefitSate = atom({
  key: "myCafateriaCalculatedBenefitSate",
  default: {
    benefit: 0,
    cost: 0,
  },
  effects_UNSTABLE: [ocPersistAtom],
});

export default myCafateriaCalculatedBenefitSate;
